import { Function } from '@vy/utils';
import { useEffect } from 'react';

export function useEffectOnce(callback: Function) {
  useEffect(() => {
    callback();
  }, []);
}
